export default __webpack_public_path__ + "static/media/038-exit.ed53ffa4.png";